import { ICellRendererParams } from 'ag-grid-community';
import { ListWithMoreChip } from '../../../../../CompanyProfiles/Companies/CompanyCard/ListWithMoreChip';
import { mergeRespondentDisplay, RespondentStatusLookup } from '../../../../../../util/respondentStatus';
import { IKpiCompanyData } from '../../AllCompaniesData';

export interface IRespondentStatusCellRendererParams extends ICellRendererParams<IKpiCompanyData, string[]> {
  title: string;
  statusLookup?: RespondentStatusLookup;
}

export function RespondentStatusCellRenderer(params: IRespondentStatusCellRendererParams) {
  const { visible, pending } = mergeRespondentDisplay(
    params.data?.respondents,
    params.statusLookup?.get(params.data?.id ?? -1)
  );
  const pendingSet = new Set(pending);

  return (
    <ListWithMoreChip
      items={visible}
      title={params.title}
      getItemColor={(email) => (pendingSet.has(email) ? 'text.secondary' : 'text.primary')}
      style={{ height: '100%', lineHeight: '1.5rem' }}
      firstItemStyle={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
    />
  );
}
